import { useState, type FormEvent } from "react";
import { useAsyncAction } from "@/hooks/useAsyncAction";
import { api, type Usuario } from "@/lib/api";

/** Lógica de la pantalla de login (sin JSX). */
export function useLoginTab(onIngreso: (u: Usuario) => void) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const accion = useAsyncAction((datos: { email: string; password: string }) => api.post<Usuario>("/api/auth/login", datos));

  const enviar = async (e: FormEvent) => {
    e.preventDefault();
    const usuario = await accion.run({ email: email.trim(), password });
    if (usuario) onIngreso(usuario);
  };

  const puedeEnviar = email.trim() !== "" && password !== "" && !accion.loading;

  return {
    email,
    setEmail,
    password,
    setPassword,
    enviar,
    puedeEnviar,
    cargando: accion.loading,
    error: accion.error,
  };
}
